import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulLayoutTemplates,
    addSinglePrintfulLayoutTemplates,
    updateSinglePrintfulLayoutTemplates,
    getSinglePrintfulLayoutTemplates,
    getAllPrintfulLayoutTemplates,
    searchPrintfulLayoutTemplates,
    searchPrintfulLayoutTemplatesWithSearchCriteria,
    preparePrintfulLayoutTemplatesList
}

const collectionName = 'printful-layout-templates';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulLayoutTemplates = (printfulLayoutTemplates) => {
    return Promise.map(printfulLayoutTemplates, async printfulLayoutTemplates => {
        await addSinglePrintfulLayoutTemplates(printfulLayoutTemplates);
    });
}

const addSinglePrintfulLayoutTemplates = (printfulLayoutTemplates) => {
    printfulLayoutTemplates.createdAt = new Date();
    printfulLayoutTemplates.updatedAt = printfulLayoutTemplates.createdAt;
    return addDoc(collectionReference, printfulLayoutTemplates);
}

const updateSinglePrintfulLayoutTemplates = (printfulLayoutTemplates) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulLayoutTemplates.id);
    printfulLayoutTemplates.updatedAt = new Date();
    return setDoc(documentReference, printfulLayoutTemplates);
}

const getSinglePrintfulLayoutTemplates = async (printfulLayoutTemplatesId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulLayoutTemplatesId);
    const printfulLayoutTemplatesDoc = await getDoc(documentReference);
    return prepareSinglePrintfulLayoutTemplates(printfulLayoutTemplatesDoc);
}

const getAllPrintfulLayoutTemplates = async () => {
    let searchQuery = query(collectionReference);
    const printfulLayoutTemplatesResult = await getDocs(searchQuery);
    return preparePrintfulLayoutTemplatesList(printfulLayoutTemplatesResult);
}

const searchPrintfulLayoutTemplates = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulLayoutTemplatesResult = await getDocs(searchQuery);
    return preparePrintfulLayoutTemplatesList(printfulLayoutTemplatesResult);
}

const searchPrintfulLayoutTemplatesWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulLayoutTemplatesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulLayoutTemplatesResult = await getDocs(searchQuery);
    return preparePrintfulLayoutTemplatesList(printfulLayoutTemplatesResult);
}

const preparePrintfulLayoutTemplatesList = (printfulLayoutTemplatesResult) => {
    const printfulLayoutTemplatesList = [];

    _.forEach(printfulLayoutTemplatesResult.docs, printfulLayoutTemplatesDoc => {
        printfulLayoutTemplatesList.push(prepareSinglePrintfulLayoutTemplates(printfulLayoutTemplatesDoc));
    });

    return printfulLayoutTemplatesList;
}


const prepareSinglePrintfulLayoutTemplates = (printfulLayoutTemplatesDoc) => {
    const printfulLayoutTemplates = printfulLayoutTemplatesDoc.data();
    printfulLayoutTemplates.id = printfulLayoutTemplatesDoc.id;
    return printfulLayoutTemplates;
}
